import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutLocationLookup extends Layout {
    sourceLocation: DataSource;
    tableLocation: Table;
}
